module.exports = __webpack_public_path__ + "static/media/Dansave-Logo_Dark.d26143c5.png";